import { render, staticRenderFns } from "./OrgAdminManagePlayers.vue?vue&type=template&id=61e3446a&scoped=true&"
import script from "./OrgAdminManagePlayers.vue?vue&type=script&lang=ts&"
export * from "./OrgAdminManagePlayers.vue?vue&type=script&lang=ts&"
import style0 from "./OrgAdminManagePlayers.vue?vue&type=style&index=0&id=61e3446a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e3446a",
  null
  
)

export default component.exports